import { render, staticRenderFns } from "./TerminalDocuments.vue?vue&type=template&id=d685a602"
import script from "./terminalDocuments.ts?vue&type=script&lang=js&external"
export * from "./terminalDocuments.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports